import { create } from "zustand";

interface NavAuthStore {
  /**
   * Cookie-derived auth state, `null` until the first client read lands.
   * Shared because the navbar is split across a static shell and two streamed
   * server slots: the shell owns the hamburger and its unread dot, the slots
   * own the profile, and both need the same answer to "is this browser signed
   * in" without waiting on `/auth/me`.
   */
  clientAuthenticated: boolean | null;
  setClientAuthenticated: (authenticated: boolean) => void;
  /**
   * Mobile menu. Lives here rather than in the sidebar because the trigger is
   * in the shell, the panel is in a streamed slot, and the search page's second
   * row collapses while it is open.
   */
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  /**
   * Which side of the marketplace the chrome last showed, for the routes that
   * imply neither. Shared rather than held per component: the pill row unmounts
   * on `/search` while the actions and the sidebar do not, so three private
   * refs drift apart and the row can end up advertising host links beside a
   * "Switch to Host" button. `null` until a route implies a side, which sends
   * callers back to the server-rendered `initialContext`.
   */
  lastContext: "host" | "driver" | null;
  setLastContext: (context: "host" | "driver") => void;
}

export const useNavAuthStore = create<NavAuthStore>((set) => ({
  clientAuthenticated: null,
  setClientAuthenticated: (clientAuthenticated) => set({ clientAuthenticated }),
  sidebarOpen: false,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  lastContext: null,
  setLastContext: (lastContext) => set({ lastContext }),
}));
